module.exports = __webpack_public_path__ + "media/images/booking-63920ae7.png";